import { Component, inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FeUtil, TYPE } from '../../../hezky-routes';

@Component({
  selector: 'app-generic-confirmation-dialog',
  templateUrl: './generic-confirmation-dialog.component.html',
})
export class GenericConfirmationDialogComponent implements OnInit {
  readonly modalData: TYPE.GenericConfirmationDialog = inject(NZ_MODAL_DATA);
  form!: FormGroup;
  protected isInvalid:boolean = false
  passwordVisible: boolean = false;
  constructor(private fb: FormBuilder, protected modal: NzModalRef, protected feUtil: FeUtil) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      password: this.fb.control(null),
      remarks: this.fb.control(null),
    });
    if (this.modalData?.displayInput?.includes('password')) {
      this.form.get('password')?.setValidators([Validators.required]);
    }
    if (this.modalData?.displayInput?.includes('remarks')) {
      this.form.get('remarks')?.setValidators([Validators.required, Validators.minLength(3)]);
    }
  }
  submitForm() {
    if (!this.feUtil.validate(this.form)) return;
    if (!this.modalData.URL) {
      this.modal.destroy(this.form.getRawValue());
      return;
    }
    this.feUtil.httpSvc.post(this.modalData.URL, { user_id: this.feUtil.user_data.user_id, ...this.form.getRawValue() }).subscribe({
      next: (res: any) => {
        const data = res?.data;
        if (!data?.isValid) {
          this.isInvalid = true;
          return;
        }
        const payload = { ...this.form.getRawValue(), isValid: data?.isValid };
        this.modal.destroy(payload);
      }
    })
  }
}
